import { CustomCard } from './CustomCard/CustomCard';
import { useOcurrencesChartsDataContext } from './hooks/useOcurrencesChartsDataContext';

export const TotalOcurrences = () => {
    const { chartData } = useOcurrencesChartsDataContext();

    const totalOcurrences = chartData?.totalOcurrences || 0;

    return (
        <CustomCard title="Total de Ocorrências" value={totalOcurrences} single />
    );
};
